import { useEffect } from "react";

import useActionCreator from "@redux/hooks/useActionCreator";

import { NOAType } from "@type/procurements/createProcurement/NOA";
import { AgreementType } from "@type/procurements/createProcurement/agreement";
import useCustomSelector from "@redux/hooks/useCustomSelector";
import { AgreementState } from "@reducers/types/procurements/create-procurements/agreement-state";
// import useCustomSelector from "@redux/hooks/useCustomSelector";
// import { NOAState } from "@reducers/types/procurements/create-procurements/NOA-state";

interface UseAgreement {
  agreementData: AgreementState;
  createAgreement: (
    data: AgreementType,
    id: string | number,
    contractAgreementId: string | number,
  ) => void;
}

export const useAgreement = (id: string | number): UseAgreement => {
  const { createAgreement, fetchAgreementDetails } = useActionCreator();

  const agreementData = useCustomSelector(
    (store) => store.procurements.agreementState,
  );

  useEffect(() => {
    fetchAgreementDetails(id);
  }, [id]);

  return {
    agreementData,
    createAgreement,
  };
};
